var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "checked",
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82604 1.53334L4.43149 5.9279C4.27421 6.08518 4.07068 6.15919 3.85789 6.15919C3.65435 6.15919 3.45081 6.08518 3.29353 5.9279L1.09163 3.73525C0.777074 3.41144 0.777074 2.90259 1.09163 2.58804C1.40619 2.27348 1.92428 2.27348 2.23884 2.58804L3.85789 4.20708L7.67883 0.386133C7.99339 0.0715758 8.51149 0.0715758 8.82604 0.386133C9.1406 0.709942 9.1406 1.21879 8.82604 1.53334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.6347623d.svg";
export { ForwardRef as ReactComponent };